import {RecentAbstractView} from "./RecentAbstractView";
import {MessageBaseView} from "../../MessageModel/view/MessageBaseView";

export class RecentPartnerRfpView extends RecentAbstractView {

    partnerRfpId: number;
    businessName: MessageBaseView | null;

    constructor(data?: any) {
        super(data);
        this.partnerRfpId = data?.partnerRfpId ?? -1;
        this.businessName = data?.businessName ? new MessageBaseView(data.businessName) : null;
    }
}